import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex-grow flex-col grid grid-cols-1 sm:grid-cols-9 items-center font-normal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1 text-center self-start flex flex-row px-4 sm:p-0 mb-8 sm:mb-0 items-center sm:items-start justify-between" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/pilogodark.png",
    alt: "Pi logo white",
    class: "w-1/3 sm:w-3/4"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/bioplastics/bpelogo.png",
    class: "w-1/3 inline-block sm:hidden",
    alt: "Logo"
  })
], -1)
const _hoisted_3 = { class: "sm:col-span-4 p-4 pt-0 pb-8" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/bioplastics/bpelogo.png",
  class: "hidden sm:block max-h-48 max-w-48 mb-auto ml-auto",
  alt: "Logo"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "flex flex-col sm:flex-row mt-auto bg-white sm:absolute bottom-0 left-0 right-0 p-4 text-black text-xs" }
const _hoisted_12 = { class: "flex flex-row flex-1 items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/eu.logo.png",
  alt: "EU Flag",
  class: "h-12 align-top mr-2 w-auto"
}, null, -1)
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content relative pb-24", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0 pb-4 overflow-auto",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 0,
                  class: "text-project2 text-5xl font-bold",
                  innerHTML: _ctx.$t(_ctx.config.title, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.config.textPart3)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.config.textPart4)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 4,
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.config.textPart4, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          (_ctx.config.bgImage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sm:col-span-4 h-full flex-col items-center flex p-32 sm:p-0",
                style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover; background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
              }, _hoisted_10, 4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", {
          innerHTML: _ctx.$t('BIOPLASTICS_INTRO.eu-footer')
        }, null, 8, _hoisted_14)
      ])
    ])
  ], 2))
}